export enum WasteTreatmentCode {
  D = 'D',
  R = 'R'
}
